import React from 'react';
import moment from 'moment';

import './Content.css';

const Content = (props) => {
    return (
        <table className="Content" style={{
            width: "100%",
            margin: "10px 0px 0px 0px",
            background: "white"
        }}>
            <tbody style={{
                width: "100%",
                border: "0",
                padding: "0",
                borderSpacing: "0"
            }}>
                {/* <tr> */}
                    <tr>
                        <td style={{
                            fontWeight: "bold",
                            fontSize: "10px",
                            textAlign: "right"
                        }}><span>{moment().format('ddd DD/MM/YYYY HH:ss')}</span> </td>
                    </tr>
                    <tr>
                        <td style={{
                            fontWeight: "bold",
                            fontSize: "10px",
                            textAlign: "right"
                        }}
                        >
                            <span>&nbsp;</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{
                            fontWeight: "bold",
                            fontSize: "25px",
                            textAlign: "center"
                        }}>
                            <span className="export_title">{props.title}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td style={{
                            fontWeight: "bold",
                            fontSize: "20px",
                            textAlign: "center"
                        }}>
                            <span className="export_desc">
                                {props.description}
                            </span>
                        </td>

                    </tr>
                    <tr>
                        <td style={{
                            fontWeight: "bold",
                            fontSize: "18px",
                            textAlign: "center"
                        }}>
                            <span>
                                Control Stations: {props.controllers}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>
                            {props.children}
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            textAlign: "center"
                        }}>
                            <span>powered by FoodZaps</span>
                        </td>
                    </tr>                                        
                {/* </tr> */}
            </tbody>
        </table>
    )
};

export default React.memo(Content);